import { useEffect, useState } from "react";
import { ExternalLink } from "lucide-react";
import { SiteNav } from "@/components/marketing/SiteNav";
import { SiteFooter } from "@/components/marketing/SiteFooter";
import { DocumentCard } from "@/components/marketing/DocumentCard";
import { DOCUMENTS, docUrl } from "@/data/documents";
import { useAuth } from "@/context/AuthContext";

function DocumentsBody({ group, eyebrow, title, text }) {
  const docs = DOCUMENTS.filter((d) => d.group === group);
  const [view, setView] = useState(docs[0]);
  useEffect(() => { document.title = `${title} | Pulse Commissioning`; window.scrollTo(0, 0); }, [title]);
  return (
    <div data-testid={`documents-page-${group}`}>
      <p className="eyebrow mb-3">{eyebrow}</p>
      <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-50">{title}</h1>
      <p className="text-lg text-slate-400 mt-4 max-w-2xl">{text}</p>
      <div className="grid lg:grid-cols-12 gap-6 mt-10">
          <div className="lg:col-span-4 space-y-4">
            {docs.map((d) => <DocumentCard key={d.id} doc={d} active={view?.id === d.id} onView={setView} />)}
          </div>
          <div className="lg:col-span-8 hidden md:block">
            <div className="panel h-[80vh] flex flex-col" data-testid="doc-viewer">
              <div className="flex items-center justify-between px-4 py-2.5 border-b border-[#1E2D4A]">
                <span className="font-mono text-xs text-slate-400">{view.title.toUpperCase()} · {view.version}</span>
                <a href={docUrl(view)} target="_blank" rel="noreferrer" className="text-xs text-slate-400 hover:text-amber-400 flex items-center gap-1" data-testid="doc-viewer-open-tab">Open in new tab <ExternalLink className="w-3 h-3" /></a>
              </div>
              <iframe key={view.id} src={`${docUrl(view)}#view=FitH`} title={view.title} className="flex-1 w-full bg-white" data-testid="doc-viewer-frame" />
            </div>
          </div>
        </div>
      </div>
  );
}

export const SalesPage = () => (
  <div className="min-h-screen bg-[#080D1A]">
    <SiteNav />
    <main className="max-w-7xl mx-auto px-5 lg:px-8 py-14 md:py-20">
      <DocumentsBody group="sales" eyebrow="Sales material" title="Sales material" text="View, download or email the Pulse Commissioning sales deck and sales sheet." />
    </main>
    <SiteFooter />
  </div>
);

export function ManualPage() {
  const { me } = useAuth();
  if (me?.is_demo) return <p className="text-slate-400" data-testid="manual-demo-blocked">The system manual is available to signed-in customers only.</p>;
  return <DocumentsBody group="manual" eyebrow="Documentation" title="System manual" text="View, download or email the Pulse Commissioning system manual. Emailed links require sign-in." />;
}
